module.exports = __webpack_public_path__ + "static/media/find.cfc00209.svg";